import React from "react";
import Card from "../../../components/Global/Card";
import { AiOutlineShop } from "react-icons/ai";
import RegisterVendedorForm from "../../../components/Forms/RegisterVendedorForm";
import GoBack from "../../../components/Utils/GoBack";

function RegisterVendedor() {
  return (
    <div className="flex flex-col w-full gap-3">
      <GoBack path="/vendedores" />
      <Card
        title="Cadastro de Vendedor"
        icon={<AiOutlineShop className="w-[25px] h-[25px]" />}
      >
        <div className="p-4 flex flex-col gap-5 w-full">
          <RegisterVendedorForm />
        </div>
      </Card>
    </div>
  );
}

export default RegisterVendedor;
